import { Box } from "orcs-design-system";
import type { Virtualizer } from "@tanstack/react-virtual";
import styled from "styled-components";

import { inboxKind, type InboxItem } from "./registry";

const VirtualRow = styled(Box)<{ $start: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: translateY(${(props) => props.$start}px);
`;

const InboxListVirtualItems = ({
  items,
  selectedKey,
  arrivedKey,
  onSelect,
  virtualizer,
}: {
  items: InboxItem[];
  selectedKey: string | null;
  arrivedKey: string | null;
  onSelect: (key: string) => void;
  virtualizer: Virtualizer<HTMLDivElement, Element>;
}) => (
  <Box
    role="list"
    aria-label="Inbox items"
    position="relative"
    width="100%"
    height={`${virtualizer.getTotalSize()}px`}
  >
    {virtualizer.getVirtualItems().map((row) => {
      const item = items[row.index];
      if (!item) {
        return null;
      }
      const { Card } = inboxKind(item.kind);
      return (
        <VirtualRow
          key={item.key}
          ref={virtualizer.measureElement}
          data-index={row.index}
          $start={row.start}
          role="listitem"
        >
          <Card
            item={item}
            selected={item.key === selectedKey}
            arrived={item.key === arrivedKey}
            onSelect={onSelect}
          />
        </VirtualRow>
      );
    })}
  </Box>
);

export default InboxListVirtualItems;
